// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3Obmi","question":"Question_question__D7JeI","description":"Question_description__3YLdY"};